import React from 'react';
import css from './Classes.module.css';
import { useNavigate } from 'react-router-dom';
import icon from '../../assets/icon.png';

const Classes = () => {
  const navigate = useNavigate();
  const cards = [
    {
      title: 'Admission Entrance Test-2 (AET)',
      description: 'On 30 March 2025',
      cta: 'Register Now',
      onClick: () => navigate('/crash-course'),
    },
    {
      title: 'Advance Batch-I',
      description: 'For all classes through AET-1 from 16 March 2025',
      cta: 'Join Us',
      onClick: () => navigate('/form'),
    },
    {
      title: '2025-26 Session',
      description: 'Admissions opening for all classes.',
      cta: 'Enquire',
      onClick: () => navigate('/form'),
    },
  ];

  return (
    <div className={css.classes} id='courses'>
      <p className={css.eyebrow}>Admissions and current batches</p>
      <h3 className={css.heading}>
        Join our classes for IIT JEE and NEET exam preparation
      </h3>
      <p className={css.subheading}>
        Structured programs, disciplined practice, and mentor-led guidance for
        students preparing for competitive exams.
      </p>
      <div className={css.cards}>
        {cards.map((card) => (
          <div className={css.card} key={card.title}>
            <div className={css.card_top}>
              <img src={icon} alt='icon' className={css.card_img} />
              <span className={css.badge}>Now open</span>
            </div>
            <p className={css.card_para}>
              <span className={css.color_text}>{card.title}</span>
            </p>
            <p className={css.card_description}>{card.description}</p>
            <button className={css.btn} onClick={card.onClick}>
              {card.cta}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Classes;
